import { ERROR } from "../../constants";

export { ERROR }

export const ADD_PARAMETER = 'ADD_PARAMETER';
export const UPDATE_PARAMETER_DATE_SYNCHRO = 'UPDATE_PARAMETER_DATE_SYNCHRO';
export const GET_PARAMETERS = 'GET_PARAMETERS';

export const SET_INDEXEDDB_TABLES = "SET_INDEXEDDB_TABLES";

export const SYNCHRO_GET_PARAMETERS = 'SYNCHRO_GET_PARAMETERS';
export const SYNCHRO_ADD_PARAMETERS = 'SYNCHRO_ADD_PARAMETERS';
